export const WELCOME_SCR = 'WELCOME_SCR';
export const GET_NAME = 'GET_NAME';
export const GET_DOB = 'GET_DOB';
export const GET_EMP_TYPE = 'GET_EMP_TYPE';
export const SET_UP_AC = 'SET_UP_AC'; // PrePopulate PAN API call
export const GET_PAN = 'GET_PAN';
export const LOADING_SCREEN = 'LOADING_SCREEN'; // For Save Questions API call
export const SUCCESS_SCREEN = 'SUCCESS_SCREEN';
export const SOFTREJECTION_LOADING_SCREEN = 'SOFTREJECTION_LOADING_SCREEN';
export const NON_TOGGLING_SCREENS = [
  WELCOME_SCR,
  LOADING_SCREEN,
  SET_UP_AC,
  SUCCESS_SCREEN,
];
